module.exports = __webpack_public_path__ + "img/744.d38702e7.jpg";